/**
 * 获取 Cookie 内容
 * @param {string} name
 */
// start_ai_generated
export const getCookie = (name: any) => {
  // 获取整个cookie字符串
  var cookieString = document.cookie
  // 分割cookie字符串，获取单个cookie数组
  var cookieArray: any = cookieString.split(';')
  // 遍历cookie数组
  for (var i = 0; i < cookieArray.length; i++) {
    // 去除空格
    var cookie = cookieArray[i].trim()
    // 分割cookie的名称和值
    var parts = cookie.split('=')
    // 检查cookie的名称是否匹配
    if (parts[0] === name) {
      // 返回cookie的值
      return parts[1]
    }
  }
  // 如果没有找到匹配的cookie，返回null
  return null
}
// end_ai_generated

/**
 * 设置 Cookie 内容
 * @param {string} name
 * @param {string} value
 * @param {number} days
 */
export const setCookie = (name: string, value: string, days: number) => {
  var now = new Date()
  now.setMinutes(now.getMinutes() + days * 24 * 60)
  document.cookie = name + '=' + value + ';expires=' + now.toUTCString() + ';path=/'
}

export const getClientCookie = (name: string) => {
  if (typeof window !== 'undefined') {
    const value = `; ${window.document.cookie}`
    const parts = value.split(`; ${name}=`)

    if (parts.length >= 2) return parts.pop()?.split(';').shift()
  }
  return null
}
